import { useState } from 'react';
import outlookLogo from '../../assets/logos/outlook.svg';
import { Button } from '../ui/button';
import { IntegrationCard, type CardMessage } from './IntegrationCard';
import { outlookAdminSteps, toneLabel } from './model';

/**
 * Outlook (Microsoft 365) as the sending mailbox, for clients not on Google Workspace. Connection is set up with the
 * client's Microsoft 365 admin on a short call, so the card lists what the admin does and takes a setup request.
 */
export function OutlookCard() {
  const [message, setMessage] = useState<CardMessage>(null);
  const primary = <Button size="sm" variant="outline" disabled={message?.kind === 'success'} onClick={() => setMessage({ kind: 'success',
    text: 'Setup requested. Your Alder contact will book 15 minutes with your Microsoft 365 admin.' })}>Request setup</Button>;
  return <IntegrationCard id="outlook" logo={outlookLogo} name="Outlook" role="Mailbox · Microsoft 365, reminders and replies"
    health={{ tone: 'off', label: toneLabel.off, detail: 'Use Outlook instead of Gmail when your team is on Microsoft 365.' }}
    summary="Alder sends reminders from your Outlook mailbox and reads customer replies in it. About 15 minutes with your Microsoft 365 admin."
    facts={[]} message={message} primary={primary}
    reassurance="Alder gets access to one shared mailbox only, approved by your admin, and nothing else in your tenant.">
    <details className="netsuite-steps">
      <summary>How to set this up</summary>
      <ol>{outlookAdminSteps.map(step => <li key={step}>{step}</li>)}</ol>
    </details>
  </IntegrationCard>;
}
